<script>
import mailcheck from 'mailcheck'

const validInputTypes = [
  'text',
  'color',
  'date',
  'datetime-local',
  'email',
  'month',
  'number',
  'range',
  'search',
  'tel',
  'time',
  'url',
  'week'
]
mailcheck.defaultTopLevelDomains.push('co')

export default {
  name: 'TextInput',
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'text',
      validator: value => {
        return validInputTypes.includes(value)
      }
    },
    value: {
      type: String,
      required: false
    },
    label: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    feedback: {
      type: String,
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'on'
    }
  },
  data() {
    return {
      currentFeedback: this.feedback,
      currentSuggestion: null,
      updatedValue: null,
      affixPadding: {
        left: '',
        right: ''
      }
    }
  },
  computed: {
    currentValue() {
      return this.updatedValue || this.value
    }
  },
  watch: {
    feedback() {
      this.currentFeedback = this.feedback
    }
  },
  mounted() {
    this.affixPadding.left = this.$refs.prefix
      ? `${this.$refs.prefix.clientWidth + 15}px`
      : '15px'
    this.affixPadding.right = this.$refs.suffix
      ? `${this.$refs.suffix.clientWidth + 15}px`
      : '15px'
  },
  methods: {
    fillSuggestion() {
      this.updatedValue = this.currentSuggestion
      this.currentSuggestion = null
      this.$emit('input', this.updatedValue)
    },
    onBlur(e) {
      if (this.type === 'email') {
        this.currentSuggestion = null
        mailcheck.run({
          email: this.currentValue,
          suggested: suggestion => {
            this.currentSuggestion = suggestion.full
          }
        })
      }
      this.onEvent(e)
    },
    onInput(e) {
      this.updatedValue = e.target.value
      this.$emit('input', this.updatedValue)
    },
    onEvent(e) {
      this.$emit(e.type, e)
    }
  }
}
</script>

<template lang="pug">
.input.input--text(:class='{ error: error }')
  label(v-if='label' :for='id') {{ label }}
  p.body--small(v-if='description') {{ description }}
  .input__container(:class='{ input__group: this.$slots.action }')
    input.error(
      ref='input'
      :value='value'
      :id='id'
      :type='type'
      :name='name'
      :placeholder='placeholder'
      :disabled='disabled'
      :style='{ "padding-left": affixPadding.left, "padding-right": affixPadding.right }'
      :class='{ "input--with-affix": $slots.prefix || $slots.suffix }'
      :autocomplete='autocomplete'
      @blur='onBlur'
      @input='onInput'
      @keyup='onEvent'
      @focus='onEvent'
      @change='onEvent'
    )

    .input__prefix(v-if='$slots.prefix' ref='prefix')
      slot(name='prefix')

    .input__suffix(v-if='$slots.suffix' ref='suffix')
      slot(name='suffix')

    .input__action(v-if='$slots.action')
      slot(name='action')

  p.body--small.input__feedback(v-if='currentFeedback || currentSuggestion')
    span(v-if='type === "email" && currentSuggestion && !feedback')
      | Did you mean&nbsp;
      a(@click='fillSuggestion') {{ currentSuggestion }}
      | ?
    span(v-else-if='feedback') {{ currentFeedback }}
</template>

<style lang="stylus">
@import '../../assets/styles/modules/*'

input[type='number']
  -moz-appearance:textfield;

input::-webkit-outer-spin-button
input::-webkit-inner-spin-button
  -webkit-appearance: none;
</style>
